import { render, staticRenderFns } from "./CommentNote.vue?vue&type=template&id=0cf48c18&scoped=true&lang=pug"
import script from "./CommentNote.vue?vue&type=script&lang=ts"
export * from "./CommentNote.vue?vue&type=script&lang=ts"
import style0 from "./CommentNote.vue?vue&type=style&index=0&id=0cf48c18&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf48c18",
  null
  
)

export default component.exports